<script>
import appbarMixin from '@/v-shop/mixins/appbarMixin'

export default {
	mixins: [appbarMixin],
	props: {
		hideText: Boolean,
		iconSize: [String, Number],
		btnClass: String,
		iconColor: String,
		iconOptions: Object,
	},
	computed: {
		cIconOptions() {
			return this.iconOptions?.iconType ? this.iconOptions : { iconType: 'default', icon: 'mdi-heart' }
		},
	},
}
</script>

<template>
	<v-btn
		v-if="$b.td"
		text
		:class="[btnClass, !hideText && 'mr-2', 'appbar__buttons_btn']"
		@click="goToFavorites"
		:color="iconColor || $vars.basetext"
	>
		<CustomIcon v-bind="cIconOptions" :icon-attrs="{ size: iconSize }" :class="!hideText && 'mr-1'" />
		<span v-if="!hideText" class="d-none d-lg-block font-1">Favoritos</span>
	</v-btn>
</template>

